/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoContattoCreateDTO
 */
export interface TipoContattoCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof TipoContattoCreateDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the TipoContattoCreateDTO interface.
 */
export function instanceOfTipoContattoCreateDTO(value: object): value is TipoContattoCreateDTO {
    return true;
}

export function TipoContattoCreateDTOFromJSON(json: any): TipoContattoCreateDTO {
    return TipoContattoCreateDTOFromJSONTyped(json, false);
}

export function TipoContattoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoContattoCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function TipoContattoCreateDTOToJSON(value?: TipoContattoCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'descrizione': value['descrizione'],
    };
}

